import { nanoid as v } from "nanoid";
import U from "lodash.debounce";
const ae = "/v1/client_events/1", oe = "/v1/client_events/2", de = "/v2/event/3e", ue = "/v2/event/session", le = "/v2/smart", he = "/v2/smartpage", pe = "/v2/facets", me = "2.4.0", R = (t, e) => {
  const { apiKey: s, source: c } = e, n = new URL(t);
  return n.searchParams.set("jdm_source", c), n.searchParams.set("jdm_version", me), s && n.searchParams.set("jdm_api_key", s), n.searchParams.sort(), n.toString();
}, _ = (t, e, s) => {
  const c = new URL(t + e);
  return R(c.toString(), s);
}, Pe = (t, e) => {
  const s = new URL(t + oe), c = new URL(t + ae);
  return {
    clickEndpoint: R(s.toString(), e),
    impressionEndpoint: R(
      c.toString(),
      e
    )
  };
};
class fe extends Error {
  constructor(e, s) {
    super(e), this.response = s;
  }
}
const C = async (t) => {
  if (t.ok) {
    if (t.status === 204)
      return null;
  } else throw new fe("Api Request Failed", t);
  try {
    return await t.json();
  } catch {
  }
}, ge = async (t, e) => {
  const s = await fetch(t, {
    body: JSON.stringify(e),
    headers: {
      Accept: "application/json",
      "Content-Type": "text/plain"
    },
    method: "POST"
  });
  return C(s);
}, ye = async (t, e = {}) => {
  const { headers: s, ...c } = e, n = await fetch(t, {
    ...c,
    headers: { Accept: "application/json", ...s },
    method: "GET"
  });
  return C(n);
}, p = { get: ye, post: ge }, _e = async (t) => {
  const {
    apiKey: e,
    endpoint: s,
    searchFacets: c,
    searchFilter: n,
    searchQuery: i,
    source: r,
    storeId: d
  } = t, a = _(s, pe, {
    apiKey: e,
    source: r
  }), l = {
    searchFacets: c,
    searchFilter: n,
    searchQuery: i,
    storeId: d
  };
  return (await p.post(a, l)).searchFacets ?? {};
}, we = async (t) => {
  const { apiKey: e, endpoint: s, identifier: c, source: n, storeId: i, ...r } = t, d = _(s, de, {
    apiKey: e,
    source: n
  }), a = {
    janeDeviceId: c.jdid,
    posOrderId: r.posOrderId,
    posUserId: r.posUserId,
    products: r.products,
    storeId: i
  };
  return await p.post(d, a);
}, be = async (t) => {
  const { apiKey: e, endpoint: s, identifier: c, source: n, ...i } = t, r = _(s, ue, {
    apiKey: e,
    source: n
  }), d = {
    distinctId: c.mixpanelDistinctId,
    events: i.events,
    janeDeviceId: c.jdid
  };
  return await p.post(r, d);
};
var j = /* @__PURE__ */ ((t) => (t.Bloom = "bloom", t.BrandEmbed = "brandEmbed", t.Default = "default", t.Embedded = "embedded", t.FramelessEmbed = "framelessEmbed", t.Headless = "headless", t.Kiosk = "kiosk", t.OperatorEmbed = "operatorEmbed", t.WhiteLabel = "whiteLabel", t))(j || {}), u = /* @__PURE__ */ ((t) => (t.CartToppers = "cart_toppers", t.MenuDynamicRow = "menu_dynamic_row", t.MenuInline = "menu_inline", t.MenuInlineTable = "menu_inline_table", t.MenuTopRow = "menu_top_row", t.PdpRow = "pdp_row", t))(u || {}), o = /* @__PURE__ */ ((t) => (t.BestSellerRank = "best-seller-rank", t.CategoryAndNameAsc = "category-and-name-asc", t.Default = "default", t.PriceAsc = "price-asc", t.PriceDesc = "price-desc", t.PriceEighthOunceAsc = "price-eighth-ounce-asc", t.PriceEighthOunceDesc = "price-eighth-ounce-desc", t.PriceGramAsc = "price-gram-asc", t.PriceGramDesc = "price-gram-desc", t.PriceHalfGramAsc = "price-half-gram-asc", t.PriceHalfGramDesc = "price-half-gram-desc", t.PriceHalfOunceAsc = "price-half-ounce-asc", t.PriceHalfOunceDesc = "price-half-ounce-desc", t.PriceOunceAsc = "price-ounce-asc", t.PriceOunceDesc = "price-ounce-desc", t.PriceQuarterOunceAsc = "price-quarter-ounce-asc", t.PriceQuarterOunceDesc = "price-quarter-ounce-desc", t.PriceTwoGramAsc = "price-two-gram-asc", t.PriceTwoGramDesc = "price-two-gram-desc", t.Rating = "rating", t.Recommendation = "recommendation", t.ThcPotencyAsc = "thc-potency-asc", t.ThcPotencyDesc = "thc-potency-desc", t))(o || {}), x = /* @__PURE__ */ ((t) => (t.Beacon = "beacon", t.ClickedAddToCart = "clickedAddToCart", t.FilteredCategory = "filteredCategory", t.ViewedProduct = "viewedProduct", t))(x || {});
class w extends Error {
  constructor(e) {
    super(`[Jane DM SDK]: ${e}`), this.name = "SdkError", Object.setPrototypeOf(this, w.prototype);
  }
}
const M = "best-seller-rank", E = "category-and-name-asc", F = "default", N = "price-asc", z = "price-desc", G = "price-eighth-ounce-asc", H = "price-eighth-ounce-desc", J = "price-gram-asc", q = "price-gram-desc", Q = "price-half-gram-asc", B = "price-half-gram-desc", L = "price-half-ounce-asc", K = "price-half-ounce-desc", $ = "price-ounce-asc", X = "price-ounce-desc", V = "price-quarter-ounce-asc", W = "price-quarter-ounce-desc", Z = "price-two-gram-asc", Y = "price-two-gram-desc", ee = "rating", te = "recommendation", se = "thc-potency-asc", ce = "thc-potency-desc", xe = [
  M,
  E,
  F,
  N,
  z,
  G,
  H,
  J,
  q,
  Q,
  B,
  L,
  K,
  $,
  X,
  V,
  W,
  Z,
  Y,
  ee,
  te,
  se,
  ce
], A = (t) => {
  switch (t) {
    case M:
      return o.BestSellerRank;
    case E:
      return o.CategoryAndNameAsc;
    case N:
      return o.PriceAsc;
    case z:
      return o.PriceDesc;
    case G:
      return o.PriceEighthOunceAsc;
    case H:
      return o.PriceEighthOunceDesc;
    case J:
      return o.PriceGramAsc;
    case q:
      return o.PriceGramDesc;
    case Q:
      return o.PriceHalfGramAsc;
    case B:
      return o.PriceHalfGramDesc;
    case L:
      return o.PriceHalfOunceAsc;
    case K:
      return o.PriceHalfOunceDesc;
    case $:
      return o.PriceOunceAsc;
    case X:
      return o.PriceOunceDesc;
    case V:
      return o.PriceQuarterOunceAsc;
    case W:
      return o.PriceQuarterOunceDesc;
    case Z:
      return o.PriceTwoGramAsc;
    case Y:
      return o.PriceTwoGramDesc;
    case ee:
      return o.Rating;
    case te:
      return o.Recommendation;
    case se:
      return o.ThcPotencyAsc;
    case ce:
      return o.ThcPotencyDesc;
    case F:
    default:
      return o.Default;
  }
}, D = (t) => JSON.parse(t);
class O {
  /**
   * Builds a new SmartSort instance based on the provided properties.
   * This method should be used in conjunction with `serialize()` to recreate the instance.
   */
  constructor(e) {
    this.searchFacets = e.searchFacets, this.nextPageUrl = e.nextPageUrl, this.nextPageProps = e.nextPageProps, this.products = e.products.map(
      (s) => new b(s)
    ), this.cachedProducts = e.cachedProducts.map(
      (s) => new k(s)
    ), this.totalProducts = e.totalProducts, this.title = e.title, this.creativeIds = e.creativeIds;
  }
  /**
   * Converts the previously-serialized object back to an instance of this class.
   * This method should be used in conjunction with `toJSON()` to recreate the instance.
   */
  static fromJSON(e) {
    return new O(
      D(e)
    );
  }
  /**
   * Boolean that indicates if more products are available for this placement.
   */
  hasNextPage() {
    return this.cachedProducts.length > 0;
  }
  /**
   * Retrieves the next page of mixed organic and sponsored products for
   * this placement.
   *
   * The `products` property will have the new products appended.
   * @example
   * ```jsx
   * function ProductsList({ placement }) {
   *   let [hasMoreProducts, setHasMoreProducts] = useState(placement.hasNextPage());
   *   let [products, setProducts] = useState(placement.products);
   *
   *   let loadMore = (async () => {
   *     await placement.nextPage();
   *     setHasMoreProducts(placement.hasNextPage());
   *     setProducts([...placement.products]);
   *   });
   *
   *   return (
   *     <div>
   *       <button onclick={() => {loadMore()}} disabled={!hasMoreProducts}>Load more</button>
   *       <div>
   *         {products.map((product) => {
   *           return (<ProductCard
   *             product={product}
   *             onClick={() => product.click()}
   *             key={product.objectId}
   *           />);
   *         }}
   *       </div>
   *     </div>
   *   );
   * }
   * ```
   */
  async nextPage() {
    var i;
    const e = this.cachedProducts.slice(
      0,
      this.nextPageProps.pageSize
    ), s = {
      object_ids: e.map((r) => r.objectId),
      search_attributes: this.nextPageProps.searchAttributes,
      store_id: this.nextPageProps.storeId
    }, c = await p.post(this.nextPageUrl, s), n = new Map(
      (i = c.products) == null ? void 0 : i.map((r) => [
        r.object_id,
        r.search_attributes
      ])
    );
    e.forEach((r) => {
      const d = n.get(r.objectId);
      d !== void 0 && this.products.push(
        new b({
          ...r.serialize(),
          attributes: d
        })
      );
    }), this.cachedProducts = this.cachedProducts.slice(
      this.nextPageProps.pageSize
    );
  }
  /**
   * Converts the object in a JSON-serializable data structure that should be
   * used **unmodified** in the constructor to create a new instance of this class.
   * This method should be used in conjunction with `new SmartSort()` to recreate the instance.
   *
   * This function is especially helpful in a server-side environment to
   * keep track of the same instance across client side and server side
   * rendered components.
   * @example
   * ```jsx
   * let serializedObj = obj.serialize();
   * let deserializedObj = new SmartSort(serializedObj);
   * ```
   */
  serialize() {
    return {
      cachedProducts: this.cachedProducts.map((e) => e.serialize()),
      creativeIds: this.creativeIds,
      nextPageProps: this.nextPageProps,
      nextPageUrl: this.nextPageUrl,
      products: this.products.map((e) => e.serialize()),
      searchFacets: this.searchFacets,
      title: this.title,
      totalProducts: this.totalProducts
    };
  }
  /**
   * Converts the object to a JSON string, using `serialize()` behind the
   * scenes. The returned value should be used **unmodified** in the
   * `SmartSort.fromJSON()` static method.
   * This method should be used in conjunction with `SmartSort.fromJSON()` to recreate the instance.
   */
  toJSON() {
    return JSON.stringify(this.serialize());
  }
}
class k {
  constructor(e) {
    this.objectId = e.objectId, this.impressUrl = e.impressUrl, this.impressPayload = e.impressPayload, this.clickPayload = e.clickPayload, this.clickUrl = e.clickUrl, this.isSponsored = e.isSponsored;
  }
  static fromJSON(e) {
    return new k(
      D(e)
    );
  }
  serialize() {
    return {
      clickPayload: this.clickPayload,
      clickUrl: this.clickUrl,
      impressPayload: this.impressPayload,
      impressUrl: this.impressUrl,
      isSponsored: this.isSponsored,
      objectId: this.objectId
    };
  }
  toJSON() {
    return JSON.stringify(this.serialize());
  }
}
class Ie {
  async createSmartSort(e) {
    const s = {
      apiKey: e.apiKey,
      source: e.source
    }, c = _(e.endpoint, le, s), n = _(
      e.endpoint,
      he,
      s
    ), i = this.buildSmartRequest(e), r = await p.post(c, i), { clickEndpoint: d, impressionEndpoint: a } = Pe(e.eventsEndpoint, s), {
      creative_ids: l,
      products: m,
      search_facets: f,
      title: g
    } = r, { cachedProducts: y, products: I } = this.generateProducts({
      clickUrl: d,
      identifier: e.identifier,
      impressUrl: a,
      placement: e.placement,
      products: m,
      storeId: e.storeId
    });
    return new O({
      cachedProducts: y,
      creativeIds: l,
      nextPageProps: {
        pageSize: "page_size" in i ? i.page_size ?? 60 : 60,
        searchAttributes: i.search_attributes ?? e.searchAttributes,
        storeId: i.store_id
      },
      nextPageUrl: n,
      products: I,
      searchFacets: f,
      title: g,
      totalProducts: r.nb_hits ?? 0
    });
  }
  buildProductIdsFilterString(e) {
    return e.length === 0 ? "" : `${Array.from(new Set(e)).map((c) => `NOT product_id:${c}`).join(" AND ")}`;
  }
  buildSmartRequest(e) {
    const { appMode: s, identifier: c, searchAttributes: n, storeId: i, ...r } = e, d = {
      app_mode: s,
      distinct_id: c.mixpanelDistinctId,
      jane_device_id: c.jdid,
      search_attributes: n,
      store_id: i
    };
    switch (r.placement) {
      case u.CartToppers: {
        const { cartProductIds: a } = r;
        return {
          ...d,
          placement: u.CartToppers,
          search_filter: this.buildProductIdsFilterString(a)
        };
      }
      case u.MenuDynamicRow: {
        const { searchFilter: a, searchOptionalFilters: l } = r;
        return {
          ...d,
          placement: u.MenuDynamicRow,
          search_filter: a,
          search_optional_filters: l
        };
      }
      case u.MenuInline: {
        const {
          disableAds: a,
          numColumns: l,
          searchFilter: m,
          searchOptionalFilters: f,
          searchQuery: g,
          searchSort: y
        } = r;
        return {
          ...d,
          disable_ads: a,
          num_columns: l,
          placement: u.MenuInline,
          search_filter: m,
          search_optional_filters: f,
          search_query: g,
          search_sort: A(y)
        };
      }
      case u.MenuInlineTable: {
        const {
          disableAds: a,
          maxProducts: l,
          numColumns: m,
          pageSize: f,
          searchFacets: g,
          searchFilter: y,
          searchOptionalFilters: I,
          searchQuery: ne,
          searchSort: ie
        } = r;
        return {
          ...d,
          disable_ads: a,
          max_products: l,
          num_columns: m,
          page_size: f,
          placement: u.MenuInlineTable,
          search_attributes: n,
          search_facets: g,
          search_filter: y,
          search_optional_filters: I,
          search_query: ne,
          search_sort: A(ie),
          store_id: i
        };
      }
      case u.MenuTopRow: {
        const { excludeCreativeIds: a, searchFilter: l } = r;
        return {
          ...d,
          exclude_creative_ids: a,
          placement: u.MenuTopRow,
          search_filter: l
        };
      }
      case u.PdpRow: {
        const { posProductId: a, productId: l } = r;
        return {
          ...d,
          placement: u.PdpRow,
          pos_product_id: a,
          product_id: l
        };
      }
      default:
        throw new w(
          `Invalid Smart Sort Placement: ${r.placement}`
        );
    }
  }
  generateProducts(e) {
    const { clickUrl: s, identifier: c, impressUrl: n, products: i, storeId: r } = e, d = {
      cachedProducts: [],
      products: []
    };
    return i == null || i.forEach((a) => {
      const l = {
        clickPayload: {
          adToken: a.ad_token,
          distinctId: c.mixpanelDistinctId ?? c.jdid,
          isAddToCart: !1,
          janeDeviceId: c.jdid,
          kevelToken: a.kevel_token,
          myHighD: a.my_high_d,
          productId: a.product_id,
          storeId: r
        },
        clickUrl: s,
        impressPayload: {
          adToken: a.ad_token,
          distinctId: c.mixpanelDistinctId ?? c.jdid,
          janeDeviceId: c.jdid,
          kevelToken: a.kevel_token,
          myHighD: a.my_high_d,
          productId: a.product_id
        },
        impressUrl: n,
        isSponsored: !!a.flight_id,
        objectId: a.object_id
      };
      a.search_attributes !== void 0 ? d.products.push({
        ...l,
        attributes: a.search_attributes
      }) : d.cachedProducts.push(l);
    }), d;
  }
}
class b {
  /**
   * Builds a new SmartSortProduct instance based on the provided properties.
   * This method should be used in conjunction with `serialize()` to recreate the instance.
   */
  constructor(e) {
    this.objectId = e.objectId, this.attributes = e.attributes, this.impressUrl = e.impressUrl, this.impressPayload = e.impressPayload, this.clickPayload = e.clickPayload, this.clickUrl = e.clickUrl, this.isSponsored = e.isSponsored, this.hasBeenImpressed = e.hasBeenImpressed ?? !1;
  }
  /**
   * Converts the previously-serialized object back to an instance of this class.
   * This method should be used in conjunction with `toJSON()` to recreate the instance.
   */
  static fromJSON(e) {
    return new b(
      D(e)
    );
  }
  /**
   * Records attribution data for this product. This method
   * should be called when the product is clicked by the user.
   * If the click is associated with an add to cart action,
   * that intent should be passed to the click method.
   * @example
   * ```jsx
   * placement.products.map((product) => {
   *   return (<ProductCard
   *     product={product}
   *     onClick={() => product.click()}
   *     key={product.objectId}
   *   >
   *     <Button
   *       title="Add to Cart"
   *       onClick={() => product.click({isAddToCart: true})}
   *      />
   *   </ProductCard>);
   * });
   * ```
   */
  click(e = { isAddToCart: !1 }) {
    const { isAddToCart: s = !1 } = e, c = {
      ...this.clickPayload,
      isAddToCart: s
    };
    return p.post(this.clickUrl, c);
  }
  /**
   * Records attribution data for this product. This method
   * should be called when the product is visible by the user in
   * the viewport, as a visible DOM element.
   * See {@link https://www.npmjs.com/package/react-intersection-observer react-intersection-observer} for a React component that can be used to detect when an element is in the viewport.
   * @example
   * ```jsx
   * import { InView } from "react-intersection-observer";
   *
   * const Component = () => (
   *   <InView onChange={(inView) => {
   *     if(inView) {
   *       product.impress();
   *     }
   *   }}>
   *     <ProductCard />
   *   </InView>
   * );
   * ```
   */
  impress() {
    return this.hasBeenImpressed ? Promise.resolve() : p.post(this.impressUrl, this.impressPayload).then(() => {
      this.hasBeenImpressed = !0;
    });
  }
  /**
   * Converts the object in a JSON-serializable data structure that should be
   * used **unmodified** in the constructor to create a new instance of this class.
   * This method should be used in conjunction with `new SmartSortProduct()` to recreate the instance.
   *
   * This function is especially helpful in a server-side environment to
   * keep track of the same instance across client side and server side
   * rendered components.
   * @example
   * ```jsx
   * let serializedObj = obj.serialize();
   * let deserializedObj = new SmartSortProduct(serializedObj);
   * ```
   */
  serialize() {
    return {
      attributes: this.attributes,
      clickPayload: this.clickPayload,
      clickUrl: this.clickUrl,
      hasBeenImpressed: this.hasBeenImpressed,
      impressPayload: this.impressPayload,
      impressUrl: this.impressUrl,
      isSponsored: this.isSponsored,
      objectId: this.objectId
    };
  }
  /**
   * Converts the object to a JSON string, using `serialize()` behind the
   * scenes. The returned value should be used **unmodified** in the
   * `SmartSortProduct.fromJSON()` static method.
   * This method should be used in conjunction with `SmartSortProduct.fromJSON()` to recreate the instance.
   */
  toJSON() {
    return JSON.stringify(this.serialize());
  }
}
function Re(t, e = 0, s = { leading: !0, trailing: !0 }) {
  const c = U(
    (n, i, r) => {
      t(...r).then(n).catch(i);
    },
    e,
    s
  );
  return (...n) => new Promise((i, r) => {
    c(i, r, n);
  });
}
function P(t, e = 0, s = { leading: !0, trailing: !0 }) {
  const c = U(
    (n, i, r) => {
      t(...r).then(n).catch(i);
    },
    e,
    s
  );
  return (...n) => new Promise((i, r) => {
    c(i, r, n);
  });
}
const De = () => typeof window < "u" && typeof document < "u", Oe = /^https?:\/\//, ke = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/, T = (t, e) => {
  const c = Oe.test(t ?? e) ? t ?? e : `https://${t}`, n = new URL(c);
  return ke.test(n.toString()) ? n.protocol + "//" + n.host : e;
}, ve = (t) => {
  const e = localStorage.getItem(t);
  return e !== null ? Se(e) : e;
}, Ae = (t, e) => localStorage.setItem(t, Ue(e)), Te = (t) => localStorage.removeItem(t), S = { get: ve, remove: Te, set: Ae }, Se = (t) => re(t) ? t.substring(1, t.length - 1) : t, Ue = (t) => re(t) ? t : `"${t}"`, re = (t) => {
  const s = t.length - 1;
  return t[0] === '"' && t[s] === '"';
}, h = 1e3;
class Me {
  /**
   * Creates an instance of the Jane DM SDK client.
   */
  constructor(e) {
    this.fetchFacets = async (r) => _e({ ...r, ...this.config });
    const { endpoint: s, eventsEndpoint: c } = e, n = T(
      s,
      "https://dmerch.iheartjane.com"
    ), i = T(
      c,
      n
    );
    this.config = {
      apiKey: e.apiKey,
      appMode: e.appMode ?? j.Headless,
      endpoint: n,
      eventsEndpoint: i,
      identifier: this.generateAndMergeIdentifier(e.identifier),
      source: e.source ?? "sdk"
    }, this.smartSortClient = new Ie(), this.fetchMenuTopRow = P(
      this._fetchMenuTopRow.bind(this),
      h
    ), this.fetchMenuRow = P(
      this._fetchMenuRow.bind(this),
      h
    ), this.fetchRecommendedPDPRow = P(
      this._fetchRecommendedPDPRow.bind(this),
      h
    ), this.fetchRecommendedRow = P(
      this._fetchRecommendedRow.bind(this),
      h
    ), this.fetchRecommendedSort = P(
      this._fetchRecommendedSort.bind(this),
      h
    ), this.fetchCartTopperRow = P(
      this._fetchCartTopperRow.bind(this),
      h
    ), this.sendPosCheckout = Re(
      this._sendPosCheckout.bind(this),
      h
    ), this.sendSessionEvent = async (r) => be({ ...r, ...this.config }), this.onLoad = () => {
      if (De()) {
        const r = {
          type: x.Beacon
        };
        this.sendSessionEvent({ events: [r] });
      } else
        throw new w("onLoad should only be called on the client-side");
    };
  }
  /**
   * Function used to generate a valid jane device id. This function is
   * intended to be used upon initial setup in a SSR environment & stored in a cookie
   */
  static generateJaneDeviceId() {
    return v();
  }
  /**
   * Retrieves the configured JDID for the client.
   */
  getJaneDeviceId() {
    return this.config.identifier.jdid;
  }
  async _fetchCartTopperRow(e) {
    return await this.smartSortClient.createSmartSort({
      ...e,
      ...this.config,
      placement: u.CartToppers
    });
  }
  async _fetchMenuRow(e) {
    return this.smartSortClient.createSmartSort({
      ...this.config,
      ...e,
      placement: u.MenuInline
    });
  }
  async _fetchMenuTopRow(e) {
    return this.smartSortClient.createSmartSort({
      ...this.config,
      ...e,
      placement: u.MenuTopRow
    });
  }
  async _fetchRecommendedPDPRow(e) {
    return await this.smartSortClient.createSmartSort({
      ...e,
      ...this.config,
      placement: u.PdpRow
    });
  }
  async _fetchRecommendedRow(e) {
    return await this.smartSortClient.createSmartSort({
      ...e,
      ...this.config,
      placement: u.MenuDynamicRow
    });
  }
  async _fetchRecommendedSort(e) {
    return await this.smartSortClient.createSmartSort({
      ...e,
      ...this.config,
      placement: u.MenuInlineTable
    });
  }
  async _sendPosCheckout(e) {
    return we({ ...e, ...this.config });
  }
  generateAndMergeIdentifier(e) {
    if (typeof window > "u") {
      if (!e)
        throw new w(
          "Identifier must be provided for server-side rendering"
        );
      return e;
    } else {
      const c = (e == null ? void 0 : e.jdid) || this.initJaneDeviceId();
      return { ...e, jdid: c };
    }
  }
  initJaneDeviceId() {
    let e = S.get("jdid");
    return (!e || e === "null" || e === "undefined") && (e = v(), S.set("jdid", e)), e;
  }
}
export {
  j as AppMode,
  Me as JaneDM,
  O as SmartSort,
  b as SmartSortProduct,
  M as bestSellerRank,
  E as categoryAndNameAsc,
  F as defaultOrder,
  N as priceAsc,
  z as priceDesc,
  G as priceEighthOunceAsc,
  H as priceEighthOunceDesc,
  J as priceGramAsc,
  q as priceGramDesc,
  Q as priceHalfGramAsc,
  B as priceHalfGramDesc,
  L as priceHalfOunceAsc,
  K as priceHalfOunceDesc,
  $ as priceOunceAsc,
  X as priceOunceDesc,
  V as priceQuarterOunceAsc,
  W as priceQuarterOunceDesc,
  Z as priceTwoGramAsc,
  Y as priceTwoGramDesc,
  ee as rating,
  te as recommendation,
  xe as searchSorts,
  se as thcPotencyAsc,
  ce as thcPotencyDesc
};
